var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 420 369", height: "367" }, props),
    React.createElement(
      "path",
      { d: "M60.11 96.282l7.66 3.035 1.878-3.901 3.181-6.07-2.458-10.695-.434-11.85-7.804-1.59-1.302-2.313-7.659-2.746-7.659-4.48-6.793 3.902-4.625-.289 1.879 3.612.433 5.925 4.481 5.06.723 6.647 4.77 2.891-2.023 7.949 7.516 3.035 2.456-4.19 4.48.433 1.3 5.635" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M52.16 104.954l-15.03.578-2.313-12.333-10.791-5.781.963-10.021-6.166-6.744 7.034-9.635 8.238-1.734 1.879 3.612.433 5.925 4.481 5.06.723 6.647 4.77 2.891-2.023 7.949 7.516 3.035 2.456-4.19 4.48.433 1.301 5.636-7.951 8.672" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M52.16 104.954l-15.03.578-2.313-12.333-10.791-5.781.963-10.021-6.166-6.744-4.672 9.875-6.215-9.972-5.058-3.468L1 73.881l6.214 7.082 3.903 10.984s12.139 7.37 12.283 7.949c.146.578 3.758 8.093 3.758 8.093l-8.816 13.151 9.25 13.875 14.741-.145 12.044-1.396 3.564-2.699 1.927-13.296-7.708-12.525z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M92.807 32.633l3.725 9.741 2.167 5.492 2.892 1.445 2.166 6.648.146 3.757-13.584.29-.578-4.77-6.65-8.382-4.769-6.359 1.59-1.589 4.77 3.035 4.77-9.539 3.355.231z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M53.173 60.15l4.336-3.469 1.59-5.492 8.816.434 4.769-7.804 5.637-3.325 4.769 6.359 6.65 8.382.578 4.77-7.372 5.348-4.335 9.394-8.239 3.902-.434-11.85-7.804-1.59-1.302-2.313-7.659-2.746z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M90.317 60.006l-7.372 5.348-4.335 9.394-8.239 3.901 2.458 10.696 7.659 2.457-.866 4.336 4.336-.145 10.259 4.191 7.084 6.071 2.745-2.602 6.358.722 1.977-5.299 3.082.193 1.362-1.602-5.409-3.553-2.745-5.058 2.601-.579 1.879-5.203 4.77.869 3.034-2.314-4.914-3.757-4.769 1.157-1.735-4.192 8.818-8.382-3.614-6.505-3.759-.289-2.746-5.203-4.48 1.301.145 3.757-13.584.29z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M57.941 130.775l-3.564 2.699.578 2.793 5.975-1.252 2.504 6.07 1.253 7.322s13.008 3.084 13.297 3.18c.289.098 1.156 7.517 1.156 7.517l4.239 6.166 13.874 3.084 4.239-7.708-.77-14.646-.868-7.01-.072-3.323-2.385-1.808-6.792-1.59-.577-2.746-2.603-1.155-.434-2.747-3.807-1.975-4.625.578.579 3.276 2.312 2.891-7.13-.771-2.423-2.175.111.055-14.067 3.275z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M60.11 96.282l-7.95 8.672 7.708 12.525-1.927 13.296L72.01 127.5l-.386-7.901 4.625.577 2.891-2.118 3.853 2.505.193 3.083 3.806 1.975.434 2.746 2.602 1.155.577 2.747 6.792 1.589.291-7.804 8.959-3.035 2.458-4.914-1.878-7.082 3.177-6.648-6.358-.722-2.745 2.602-7.084-6.071-10.259-4.191-4.336.145.866-4.336-7.659-2.457-3.181 6.07-1.877 3.901" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M78.561 124.224l4.625-.578-.193-3.083-3.853-2.505-2.891 2.118-4.625-.577.386 7.901-.112-.056 2.423 2.176 7.13.77-2.311-2.89-.579-3.276z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M98.41 206.121l4.816 10.214 4.433.578 6.359 5.202 4.433 4.625-3.276 2.12 12.526 5.202 7.9 2.892 7.708-8.479 6.358 3.469 7.901 2.697 2.312-10.405 5.011-4.818 1.927-3.662 4.114.575-1.802-6.355-5.588-3.47-.577 4.048-8.096-1.929-7.708-8.479-7.515-5.395 8.864-11.562-5.78-5.781 1.927-5.587-.436-.542-5.78-7.215-1.493 8.142-3.467-.578.48 5.3-5.684 8.959-4.625.579-3.083 6.552-13.104-1.541-9.055 14.644" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M85.499 196.871l-1.83 2.457-5.782-4.624-6.07-11.129-8.383-5.781s-11.994-15.898-12.429-16.188c-.434-.288-9.25-.722-9.25-.722l-4.77-7.37-5.348-9.683-4.046-8.816 14.741-.145 12.044-1.396.578 2.793 5.975-1.252 2.504 6.07 1.253 7.322s13.008 3.084 13.297 3.18c.289.098 1.156 7.517 1.156 7.517l4.239 6.166 13.874 3.084-.384 8.092-6.746 4.819-.577 8.286-4.046 7.32" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M133.771 174.814l-6.169-2.656 2.025-6.071-4.192-2.167-4.191-5.637-1.59-8.382-5.443-3.903h-13.488l.77 14.646-4.239 7.708-.384 8.092-6.746 4.819-.577 8.286-4.047 7.322 5.78 2.892 7.131 6.358 9.057-14.645 13.104 1.541 3.083-6.552 4.625-.579 5.684-8.959-.193-2.113z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M165.758 138.29l-.405-.063-4.508-.707-.724 6.6-5.828 2.649-6.455-2.359-10.695.24-5.589-3.275-4.624 2.891-6.938-.194-1.735-2.119-4.046 4.046 5.443 3.903 1.59 8.382 4.191 5.637 4.192 2.167-2.025 6.071 6.169 2.656-.289-3.187 3.467.578 1.493-8.142 5.78 7.215.436.542 5.01 1.733L162 183.383l1.928-2.699-1.928-6.359 4.241-.384 5.009-8.286 1.35-21.968-7.247-5.459.405.062z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M144.658 171.821l-1.927 5.588 5.781 5.781-8.865 11.562 7.515 5.394 7.708 8.479 8.096 1.929.77-6.553 6.552-1.54-1.349-9.828-6.361-4.625-1.076-5.022-.001-.001-11.833-9.43" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M203.433 139.832l-4.819-3.854-21.773 2.121-4.24 5.587-1.35 21.968-5.009 8.286-4.242.385 1.928 6.359-1.928 2.699-.498-.396 1.076 5.021 6.361 4.625 1.349 9.828-6.552 1.54-.193 2.505 5.588 3.47 1.802 6.355 4.172.582 1.543-22.546 9.827 1.348 3.274-2.119.386-3.854 9.058 1.734-1.735-5.59 3.277-.578-2.313-9.634-4.625-1.542.963-4.431 6.167-9.057-1.543-8.865 3.47-4.047.579-7.9z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M151.03 99.39l-2.711 8.454-.193 1.252-5.105.868s-10.503-.193-10.792-.193-7.901 4.143-7.901 4.143-4.335 6.07-4.722 6.07c-.384 0-5.202-2.891-5.202-2.891l-5.298 1.012-1.879-7.083 3.178-6.648 1.977-5.299 3.082.192 3.276-3.854 6.07-.579 4.432-5.685s1.445-4.335 1.832-4.335c.384 0 3.854 3.468 3.854 3.468l-4.433 1.734 2.41 2.698-1.351 2.024 4.528 6.262v4.143l4.048-.096 3.95-2.12 6.744-3.662" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M325.404 323.356l-6.97 3.11-.158 4.751-3.959 2.218-9.662.794v4.909l3.485 5.067-1.109 11.878 15.045 1.743 3.168-6.493 4.911 1.108 5.543-3.167 3.802-.791 8.394-8.871h7.76l2.535-5.384 6.969-1.108.315-3.802 3.591-2.853 1.161-4.196h-6.229l-3.907 5.78h-8.234l-2.324-1.584-5.746-2.111-2.068 4.964h-3.168l-2.374-3.01-6.652 1.11-4.278-3.327.159-.735z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M157.762 133.281l-7.516-.193-9.635-7.707 2.698-10.792 4.047-1.541.729-3.943-5.065.86s-10.503-.193-10.792-.193-7.901 4.143-7.901 4.143-4.335 6.07-4.722 6.07c-.384 0-5.202-2.891-5.202-2.891l-5.298 1.012-2.458 4.914-8.96 3.035-.29 7.804 2.385 1.808.072 3.323.868 7.01h13.488l4.046-4.046 1.735 2.119 6.938.194 4.624-2.891 5.589 3.275 10.695-.24 6.455 2.359 5.828-2.649.724-6.6-3.082-4.24z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M384.796 314.433l4.593.791 2.059 3.642 4.435 1.268-1.901 3.642 3.168 7.286-6.178 4.592-3.326 3.959h-4.434l-7.601-7.443-10.454.951.316-3.802 3.59-2.852 1.162-4.196h-6.229l-3.907 5.78h-8.235l-2.324-1.584-5.746-2.112.308-.737-.157-2.535 3.959-3.009 5.226.685 3.905-4.326 1.163-4.12 3.061-1.584 8.448.529 4.118 7.285 7.075-1.319 3.906-.791" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M332.531 310.948l5.701-.317 8.871 4.593.791 2.85-3.959 3.009.157 2.535-2.375 5.701h-3.168l-2.374-3.009-6.653 1.11-4.278-3.327 1.744-8.078 2.691-4.91" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M304.655 339.139v-4.909l9.662-.794 3.959-2.218.158-4.751 6.97-3.11-.16.736 1.744-8.078 2.69-4.909-.475-4.276-2.533-3.168h-3.96l-2.535 1.267-12.035 1.109-7.286 5.228-2.534 3.168h-7.919l.95 6.809 6.969 5.226 2.534 4.437-3.8 4.118 3.8 5.858 4.265-1.066-.464-.677z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M347.894 318.074l5.226.685 3.905-4.326 1.163-4.12 3.061-1.584 8.448.529 4.118 7.285 7.075-1.319 3.906-.791-1.478-5.493-4.963-1.266-7.919-2.006-7.707-2.007-3.167-4.117-11.192 1.9-3.643 5.385-6.336.951-.159 2.851 8.871 4.593" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M347.894 297.485l1.267-6.97-2.534-3.483 4.435-4.594 8.87 1.267 7.441-9.025-4.115-5.386-6.258-6.178-10.374 2.693-7.443 6.705-7.761 2.479-6.178 2.219v3.325l5.544 4.752 8.87 5.543-1.584 8.711 9.82-2.058" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M367.372 274.68l7.288.315 4.224 9.502 7.708 1.215 6.439 1.056 2.113 7.179 7.707 2.746 4.331 6.968-3.169 5.174-14.624 6.389-4.593-.791-1.478-5.493-4.963-1.266-7.919-2.006-7.707-2.007-3.167-4.117v-4.274l-2.958-1.586-3.484 3.009-5.226.792 1.266-6.969-2.534-3.484 4.435-4.594 8.87 1.267 7.441-9.025z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M325.244 280.538l-.202 8.025-2.753 9.291-2.639.528 2.005 5.806-1.479.739-12.035 1.109-7.286 5.228-2.534 3.168h-7.919l.064.799-2.915-.799-2.216-5.228 6.968-3.01-1.109-4.116-3.167-1.11-2.691-6.652-3.011-1.267v-2.534h6.652l7.444-2.533 4.434-3.485 5.227 4.91 7.365-1.108 2.613-3.802-1.584-3.484 3.169-4.592 7.6.792v3.325h-.001z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M338.074 299.544l9.82-2.059 5.226-.792 3.484-3.009 2.958 1.586v4.274l-11.192 1.9-3.643 5.385-6.336.951-.159 2.851-5.701.317 2.216-5.861 3.327-5.543" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M322.711 303.661h3.96l2.533 3.168.475 4.276 2.853-.157 2.216-5.861 3.327-5.543 1.584-8.711-8.87-5.543-5.544-4.752-.202 8.025-2.753 9.291-2.639.528 2.005 5.806 1.055-.527z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M159.382 85.635l4.256-1.686-.577-2.312-2.6 1.446-1.736-2.024 3.084-4.335-6.167-5.492 5.492-4.24-1.831-2.602-2.313.675-7.515-5.106-4.144 2.12-6.359-2.891-.578 8.19L133 67.28l-.867 2.313 2.697 3.757-4.047 4.528 6.552 2.794 3.469 5.685 4.721-1.927 2.987-.771 3.661 2.698.676 2.119 1.926-.481.276.267 1.65-4.314 2.681 1.687z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M116.185 45.987l-7.948 8.671 2.746 5.203 3.759.29 3.614 6.504-8.818 8.382 1.735 4.192 4.769-1.157 4.914 3.757 6.938-5.203 1.879-3.902 5.059.626-2.697-3.757.865-2.313 5.395.097.578-8.19 1.967.894 3.861-2.676.579-5.926-2.745-2.167-4.853-10.278-.206.45-6.214-1.012-7.083 6.503-8.094 1.012" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M137.335 80.673l-6.552-2.794 4.047-4.528-5.059-.626-1.879 3.902-6.938 5.203-3.034 2.313-4.77-.869-1.879 5.203-2.602.579 2.745 5.059 5.409 3.552 1.914-2.251 6.07-.579 4.432-5.685s1.445-4.335 1.832-4.335c.384 0 3.854 3.468 3.854 3.468l3.565.963 2.312-2.89-3.467-5.685z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M116.185 45.987l8.095-1.012 7.083-6.503-6.938-6.215-4.335-7.948-9.106.723-.434 4.914-.577.094 2.602 2.942-1.012 7.081 4.622 5.924" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M109.972 30.039l2.602 2.942-1.012 7.081 4.623 5.926-7.948 8.671-4.48 1.301-2.166-6.648-2.892-1.445-2.167-5.492-3.725-9.741.833.058 16.332-2.653z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M120.089 24.309l4.335 7.948 6.938 6.215 6.214 1.012 5.204-11.418 2.021-4.336 5.781 1.157 1.158-3.324 3.757-2.312.579-6.215-4.625.289.144-7.949S135.987.606 135.698 1.04c-.289.435-2.457 5.203-2.457 5.203l7.226 6.215-7.081 3.324-13.297 8.527z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M176.887 18.671l-.818-12.38 10.983-.963 6.745 3.468 1.928 10.213-2.218 3.998-7.081-1.445-3.18 12.285 1.3 8.864-1.925 4.432-6.745-3.758-2.313-6.07 3.035-2.891-1.733-7.226 3.902-3.903-1.88-4.624z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M212.49 51.382l-5.687-1.927-4.914 5.203-8.672-3.372-1.83-5.589-.289-3.372-6.553.385-1.3-8.864 3.18-12.285 7.081 1.445 2.218-3.998 4.045 7.516h9.251l4.817 21.968-1.347 2.89" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M174.864 27.199l3.902-3.903-1.88-4.625-9.537-.433-2.892 4.769-5.057-.867-3.903-2.89-3.757 2.312-1.158 3.324-5.781-1.157-2.021 4.336-4.989 10.947-.009.021 4.853 10.278 2.745 2.167-.579 5.926-3.861 2.676 4.393 1.997 4.144-2.12 7.515 5.106 2.313-.675-1.927-4.914 4.529-8.382 1.155-3.083 5.107.097 4.239-5.781 3.469 1.06-2.313-6.07 3.035-2.891c-.001.001-.001.001-1.735-7.225z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M219.233 70.459l-5.202 2.121-5.927-4.191-7.516 7.515.867 5.781.345.135-2.608 4.73-5.01-.096-.194 3.854-8.767.771 1.637-3.854-5.299-3.469-7.129 1.734-5.012-5.202-5.876.77.193-3.179 3.468-2.602 8.383 2.313 1.831-5.492 6.069-3.758 2.89-7.515-1.831-8.575 4.528 1.06 4.144-2.023 8.672 3.372 4.914-5.203 5.687 1.927 4.046 5.781 4.625 10.406-1.928 2.889" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M159.303 64.39l1.831 2.602-5.492 4.24 6.167 5.492-3.084 4.335 1.736 2.024 2.6-1.446.482-.579.193-3.179 3.468-2.602 8.383 2.313 1.831-5.492 6.069-3.758 2.89-7.515-1.831-8.575 4.528 1.06 4.144-2.023-1.83-5.589-.289-3.372-6.553.385-1.925 4.432-6.745-3.758-3.469-1.06-4.239 5.781-5.107-.097-1.155 3.083-4.529 8.382 1.926 4.916" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M249.007 40.206l-4.048-2.746-6.938 5.492-1.879-7.516-6.794.724-2.455-6.505-5.348 1.301-12.525-4.432 4.817 21.968-1.348 2.89 4.046 5.781 4.625 10.406-.653.979 12.984-6.374.387-5.974 7.129-1.349 5.59-8.094 6.552-2.698 1.733-6.937-5.875 3.084z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M202.606 148.022h2.896l6.216-6.937-4.48-2.746 3.758-3.613 2.747-7.371 4.624-2.746-11.129-11.562 2.341-7.848-10.482-7.568-9.442 7.033-5.587 1.735-4.819 2.119-2.216 2.794-4.721-2.216-.866 4.625 3.469 7.516-2.796 5.202 2.796 5.492-7.517 1.446-1.639 4.914-.405-.063 7.247 5.459 4.24-5.587 21.773-2.121 4.819 3.854-.579 7.901" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M160.845 137.52l4.508.707.405.063 1.639-4.914 7.517-1.446-2.796-5.492 2.796-5.202-3.469-7.516.866-4.625-1.444-3.372 2.216-3.565-3.854-2.987-6.457.482-1.444-7.998 2.504-3.083-3.758-2.505-3.372-2.12-1.65 4.314-.002-.001 3.002 2.914-2.892 4.046 1.639 3.758-2.698 2.215-3.08-1.812.011.007-2.711 8.454-.963 5.203-4.047 1.541-2.698 10.792 9.635 7.707 7.516.193 3.081 4.242" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M199.192 86.55l-5.009-.096-.195 3.854-8.766.771 1.636-3.854-5.298-3.469-7.129 1.735-5.012-5.202-5.876.769-.482.579.577 2.312-4.255 1.686.69.434 3.758 2.505-2.504 3.083 1.444 7.997 6.458-.482 3.853 2.988-2.216 3.565 1.445 3.371 4.72 2.217 2.216-2.795 4.819-2.119 5.587-1.734 9.443-7.034 4.818-8.961-4.722-2.12z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M218.8 88.188l-6.939-.578-3.033-3.034-7.027-2.757-2.609 4.731 4.722 2.12-4.818 8.961 10.743 7.756 4.625.723 5.926-3.325 9.249-1.444 1.3-2.747-3.467-3.902-6.36-2.024-2.312-4.48" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M209.578 105.199l-2.341 7.848 11.129 11.562-4.624 2.746-2.747 7.371-3.758 3.613 4.48 2.746-6.216 6.937 9.25 2.312 1.736-4.335 4.045 1.156 1.157-3.034 2.746.579 5.01-12.768 5.974-2.119 2.698-4.046.385-5.781-2.312-4.24-3.662-5.974 3.469-6.986-6.359-1.444-9.249 1.444-5.926 3.325-4.625-.724-.26-.188z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M232.723 84.143l-4.818 3.323-3.613-3.468-5.491 4.19-6.938-.578-3.033-3.035-7.372-2.891-.867-5.781 7.516-7.515 5.927 4.191 5.202-2.121 7.322 4.626 5.589 2.891.576 6.168z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M273.575 86.31l-6.071-2.312-12.717 11.417-3.613 7.37-5.637-2.457-2.794.771 1.541 10.406 5.589-.386 1.348-4.24 2.12.386 8.479 3.468 8.095 3.276 2.504 2.699 3.855-3.47 6.551.579 1.157-7.13-2.698-7.13 6.357-3.662 2.507-15.608-2.507.384-7.321 9.635-6.745-3.996" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M219.233 70.459l7.322 4.626 5.589 2.891.578 6.167 4.287 1.011 2.383-5.35-2.431-7.802 7.997-.722 9.924-6.601-4.625-7.13 10.214-6.937 3.084-6.553-6.553-7.13-2.12.193-1.733 6.937-6.552 2.698-5.59 8.094-7.129 1.349-.387 5.974-12.984 6.374-1.274 1.911z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M271.696 78.939L261.579 69.4l-1.733-4.48-5.369-.867.406.626-9.924 6.6-7.997.722 2.431 7.803-2.383 5.349-4.287-1.01-4.819 3.323-3.613-3.468-5.491 4.19 2.312 4.48 6.36 2.024 3.467 3.902-1.3 2.747 6.359 1.444 4.047-.866 5.492-1.59 5.637 2.456 3.613-7.37 12.717-11.417 6.071 2.312-1.879-7.371z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M284.172 139.447l1.158 3.662 3.275.578v9.058l3.275 5.204-3.083.962 1.35 7.13-9.636-1.348-3.469 2.312h-2.312l-3.085 3.469-4.238-3.854-1.542-6.552-3.468-.962-1.35-7.13 2.89-7.708-.962-4.625 8.287-1.156.962-3.662 10.791.386 3.275 2.891-2.118 1.345z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M282.824 113.818l-6.551-.579-3.855 3.47-2.504-2.699-8.095-3.276-8.478-3.468-2.12-.386-1.348 4.24-5.589.385-1.541-10.405-2.698.819-4.047.866-3.469 6.986 3.662 5.974 2.312 4.239-.385 5.781 13.681 5.588 11.178 8.287 8.287-1.157.962-3.661 10.791.386 3.275 2.891.966-.579 2.311-7.515-2.698-8.287" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M262.977 139.64l-11.178-8.287-13.681-5.588-2.698 4.047-5.974 2.119-5.009 12.768 5.056 10.839-1.3 6.069 8.769 3.469 8.093 4.239 9.251 2.312 1.733-6.165-3.468-4.625 2.505-5.974 2.504-3.662h3.758l2.6-6.936-.961-4.625z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M186.475 195.715l1.396 3.902 2.167.146 5.059-3.469 5.78.866 10.552 6.794 2.022-4.479-5.347-5.06 6.647-6.937 2.747-6.794-.868-9.393 4.481 2.312 1.877-8.093 5.204-3.902 1.3-6.069-5.057-10.839-2.746-.579-1.157 3.034-4.045-1.156-1.736 4.335-9.25-2.312h-2.896l-3.223 3.758 1.543 8.865-6.167 9.057-.963 4.431 4.625 1.542 2.313 9.634-3.277.578 1.735 5.59-9.058-1.734-.386 3.854-3.272 2.118" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M213.451 199.475l6.168-.484 6.551-3.661 9.443-4.625 5.781.385 6.166-1.928 7.129-3.853-.383-13.682-9.251-2.312-8.093-4.239-8.769-3.469-5.204 3.903-1.877 8.093-4.481-2.311.868 9.392-2.747 6.795-6.648 6.936 5.347 5.06" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M267.215 200.146l1.158-5.972-4.047-5.975-2.699 1.158-6.938-4.048-7.129 3.853-6.166 1.928-5.781-.385-9.443 4.625-6.551 3.661-6.168.484-2.022 4.479 9.346 4.866 7.322-1.927 8.094 4.432 10.02 7.515 17.15 1.155 4.433-7.321-1.541-6.938.962-5.59z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M267.408 166.617l-1.542-6.552-3.468-.962-1.349-7.13.387-.772h-3.856l-2.504 3.662-2.505 5.974 3.468 4.625-1.733 6.165.383 13.682 6.938 4.048 2.699-1.158 4.047 5.975 5.01-1.541 5.01 3.276 4.431-4.819-5.781-.577-2.505-5.396 4.239-2.12-4.046-3.662-5.204-2.696.22-7.896" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M282.824 191.09l11.564-2.891 2.503 6.746-1.156 6.937 3.662 8.672 7.514 2.889-5.781 10.02-1.154 5.783-2.506.385-1.735-9.442-11.37-1.349-2.89.192-1.156-4.624-12.525-1.734-1.541-6.938.962-5.59 1.158-5.972 5.01-1.541 5.01 3.276 4.431-4.819" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M277.813 166.426l3.083 6.744 2.698-1.927-.578 9.636-4.239 2.119-4.239 2.12 2.505 5.396 5.781.577 11.563-2.891 6.165-1.926 2.505-4.24.578-5.78 4.239-3.083-2.697-6.744.386-5.588-6.166-10.406-3.276-3.662-3.854 1.735 2.698 4.046-3.468 4.787-.004-.008.388.618-3.083.962 1.35 7.13-9.636-1.348-2.668 1.778-.031-.045z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M70.369 287.604l-3.959 1.107-1.187 1.743 2.574 7.126v6.81l-2.178 4.91.95 4.118-4.276 6.971-6.336 1.424-1.108-3.483-5.543-.158v2.849l1.9 2.375-.634 2.535h2.878l3.776 9.184 10.611.477.157 6.968 6.336 2.218 7.707-2.533 4.805-3.327 1.585-7.286-2.852-2.851v-5.7l1.742-3.483-3.169-1.903-.473-2.692 7.442-5.861-1.898-2.058-.158-8.712 2.056-7.76-3.8-.475v2.851l-6.335 7.917-3.486.318-1.898-6.652" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M40.12 308.827l-.793 2.216-2.216 1.268h-6.495v3.326l7.128 7.917 6.652.951 1.267 3.327 2.799.634 2.11-2.535.634-2.535-1.9-2.375v-2.849l5.543.158 1.108 3.483 6.336-1.424 4.276-6.971-.95-4.118-8.393-3.801-6.02 2.297-2.744 3.562-2.956.477-5.386-3.008" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M65.619 309.3l-8.393-3.801-6.02 2.297-2.744 3.562-2.956.477-5.386-3.008-.793-5.545 2.376-1.742.475-6.969-2.851-1.741v-4.752l3.803-.635 5.332-6.808 2.744-1.268 2.189-6.018 1.929-2.535 5.227 1.901 3.484.158 2.059 7.287 4.275 7.444-3.959 1.107-1.187 1.743 2.574 7.126v6.81l-2.178 4.91z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M311.729 143.687l4.626 6.359 3.275 1.349 2.119-5.203 5.589-3.083.964-3.854 4.817 1.156 5.012-2.505-.387-4.818 4.818-9.635-2.313-3.083-8.093-.963-1.542 3.083-5.203.963-7.707 8.286-6.552 2.891 1.541 3.854-.964 5.203z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M289.569 130.005l4.818 1.348 3.467 3.855 5.012 4.817 8.862 3.662 4.626 6.359 3.275 1.349 2.119-5.203 3.084 2.891-1.542 5.395-2.119 1.927.577 4.434-8.093 4.046-3.275 1.542-4.817-5.588-6.166-10.406-3.276-3.662-3.854 1.735 2.698 4.046-3.468 4.787-2.892-4.594v-9.058l-3.275-.578-1.158-3.662 3.086-1.927 2.311-7.515" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M357.014 134.437l1.735-5.395-5.588-2.121-4.432-6.358-6.166 2.89-4.819 9.634.387 4.819-5.012 2.505-4.817-1.157-.964 3.854-5.589 3.084 3.084 2.891-1.542 5.394 6.167 3.47 3.854-3.277 5.396-.193.577-3.854 2.699-2.119 6.359 1.735 2.889-6.746 9.058-1.734-3.276-7.322z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M308.261 110.542l5.781 4.625 8.094-2.698.386 5.01 5.78-5.781 3.854 7.708 8.093.963 2.119-9.057 5.012-3.661v-7.323l2.891-1.734-3.662-3.276-5.396-8.093-3.276.192-2.697-5.396 5.974-2.698 3.082-3.468-1.156-5.781-2.89-2.697-5.396 4.432-7.516.386s-2.698 1.349-3.468 1.542l-.579 5.01-9.441 6.359-.965 8.287-4.045 6.359-.579 10.79z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M290.147 80.289l6.358-3.084 2.697.578-.578-6.745-5.78-4.817-2.891-5.588 2.891-4.432 11.176 4.239 5.588 1.735 5.589 5.974h3.469l5.204 4.817-.579 5.781-9.441 6.359-.965 8.287-4.045 6.359-.579 10.792-2.312 2.312-7.324.578-7.9-4.625-6.743-2.119-2.698-7.13 6.357-3.662 2.506-15.609" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M283.981 106.688l-1.157 7.13 4.047 7.9 2.698 8.287 4.818 1.348 3.467 3.855 5.012 4.817 8.862 3.662.965-5.203-1.541-3.854 6.552-2.891 7.707-8.286 5.203-.963 1.542-3.083-3.854-7.708-5.78 5.781-.386-5.01-8.094 2.698-5.781-4.625-2.312 2.312-7.324.578-7.9-4.625-6.744-2.12z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M360.29 141.759l2.409 1.928 7.032-1.253 5.011 2.408 4.434-1.155-2.844-4.48-3.612-9.54-.094-4.715-.004.042-2.891-3.468 1.35-2.12-2.505-6.359-3.854.192-2.263 2.553-3.325-1.589-4.047 4.335-6.358 2.025 4.432 6.358 5.588 2.121-1.735 5.395 3.276 7.322" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M342.563 123.453l6.166-2.89 6.358-2.024 4.047-4.335 3.325 1.589 2.263-2.553 1.157-5.395 2.697-.386 5.396-8.479-4.818-1.542-5.973-6.552-2.505.771 1.541 4.433-7.707 3.083-4.239-.578-2.891 1.734v7.323l-5.012 3.661-2.119 9.057 2.314 3.083" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M372.622 124.994l4.818-3.854 4.818-.385 2.89-1.734 2.601 4.865 3.036.289 1.59 3.614-4.626 2.601 3.904 3.035 3.324 9.972-2.602 6.792-4.77 2.892-8.093-8.961-3.18-4.913-3.612-9.54-.094-4.715-.004.042z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M208.563 288.409l-6.807 7.079-7.351 4.627-4.357 1.361-1.36 3.949 3.54 3.402.407 5.99 4.9-.408 1.771 2.586 4.9 1.225-.272 3.54-4.084 3.266-2.042-2.179-2.04-.135-2.18 2.857-3.266-1.904-1.498.953 2.315 4.22.545 3.403-3.131 1.362-2.179-1.634-4.901 2.994-1.36 1.363 1.497 1.905 3.267.545s3.402 5.31 3.812 5.445c.407.136 4.9 0 4.9 0l6.126-5.854 2.86-3.948 1.224-3.13 4.22.818 4.492-.954 3.403 1.905 5.445-1.088 2.995-6.261 2.041-2.315-.68-3.54-2.18-1.633 1.091-4.356-3.404-2.586-1.634 2.722-1.224-1.906-1.633-6.262-3.54-9.256-1.77-.681-1.632 2.177-2.588-4.355 2.588-1.906-1.234-4.211.008.808z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M192.635 314.818l-1.36 6.058-2.383-.137-1.701-3.063-5.515-.748-.815 2.722-.681 5.718 3.267 2.178 2.86 1.429.067 2.996 2.177 1.633 3.132-1.363-.545-3.402-2.315-4.22 1.499-.952 3.266 1.904 2.18-2.858 2.04.135 2.042 2.18 4.084-3.267.272-3.54-4.9-1.226-1.77-2.585" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M192.635 314.818l-1.36 6.057-2.383-.136-1.701-3.064-5.515-.748-2.38-.748-.273-4.764-2.791-2.11-4.288 2.585v3.133h-2.382l-3.403-6.536s-1.565-4.558-1.43-4.832c.137-.272 5.378-7.419 5.378-7.419l1.701.34 5.446-.68s.816-2.859.884-3.2c.068-.34-1.36-2.518-1.223-2.791.135-.272 1.428-4.56 1.428-4.56s5.309-3.47 5.513-3.402c.204.067.544-6.876.544-6.876l5.037.205 2.86-1.769 2.926-1.43 5.58 2.315 2.86 5.444 4.902 4.22v4.356l-6.807 7.08-7.351 4.626-4.357 1.362-1.36 3.948 3.539 3.403.406 5.99z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M385.148 119.021l5.781-1.349 4.238-1.735 2.314-.579 1.733 6.071s4.528 1.831 4.913 2.023c.387.193 2.506 2.409 2.506 2.409l4.047-.674 1.734 10.694 1.734 3.084-6.069 4.142-4.723-1.349-4.239.963-4.143.674-3.323-9.972-3.904-3.035 4.626-2.602-1.59-3.613-3.036-.289-2.599-4.863z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M379.176 103.412l.193 4.625 3.467 5.396 2.505 3.083-.193 2.505 5.782-1.349 4.238-1.735-2.118-4.817-6.552 1.541-3.662-10.984" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M382.836 101.677l3.662 10.984 6.552-1.541 2.118 4.817 2.314-.579-2.505-9.248-1.348-3.084-4.243.964-6.55-2.313z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M305.563 160.837l-.385 5.589 2.697 6.744-4.239 3.083-.578 5.78 5.589 1.157.193 2.697 5.878-1.058 1.251-4.336 7.226-4.529 7.997-4.721-.193-3.854 2.891.77 4.047-1.733 1.734-5.781 10.6-2.025 2.792-2.889-.191-3.181-1.929.097-2.6-2.408-6.359-1.735-2.699 2.119-.577 3.854-5.396.193-3.854 3.277-6.167-3.47-2.119 1.927.577 4.433-8.093 4.046-3.275 1.543" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M360.29 141.759l2.409 1.928 7.032-1.253 5.011 2.408 4.434-1.155.336.433 8.093 8.961-1.974 6.6-9.25 3.661-4.818 4.335-.29 5.878-3.275.193-2.986-8.576-5.109-1.059-3.757-3.661-3.083-4.721-.191-3.181-1.929.097-2.6-2.408 2.889-6.746 9.058-1.734" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M367.998 173.748l-2.986-8.575-5.108-1.06-3.757-3.661-3.083-4.721-2.793 2.889-10.6 2.024-1.734 5.781-4.047 1.733.771 2.121 3.083 1.252-2.023 1.926 3.18 2.313 2.506-1.735 4.336 1.35 10.021-.963.866 3.276 5.011 2.601 8.092 4.337 1.542-11.081-3.277.193z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M306.911 213.443l2.409-4.142 5.109-4.045 9.441 4.623 4.625-.771-.579-4.528-5.299-6.359-1.638-5.783-2.793-.961-2.989-2.698-.479-3.95-5.878 1.058-.193-2.697-5.589-1.157-2.505 4.24-6.165 1.926 2.503 6.746-1.156 6.937 3.662 8.672" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M323.195 175.964l2.697 3.661 4.336 2.505 5.975 2.505 3.661 8.092 4.913.579 5.493 6.264 5.492-.096 3.371-9.443 6.358-1.061 4.239-4.335-8.092-4.337-5.011-2.601-.866-3.276-10.021.963-4.336-1.35-2.506 1.735-3.18-2.313 2.023-1.926-3.083-1.252-.771-2.121-2.891-.771.193 3.854-7.994 4.724z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "path",
      { d: "M350.271 199.57l-5.493-6.264-4.913-.579-3.661-8.092-5.975-2.505-4.336-2.505-2.697-3.661-7.227 4.529-1.251 4.336.479 3.95 2.988 2.697 2.794.962 1.638 5.782 5.299 6.359.523 4.101 4.005-1.21 3.661 2.505 6.457-4.239 3.564-.48 4.528-5.686h-.383z" },
      React.createElement("title", null)
    ),
    React.createElement(
      "text",
      { x: "45", y: "255" },
      "Brno"
    ),
    React.createElement(
      "text",
      { x: "170", y: "255" },
      "Ostrava"
    ),
    React.createElement(
      "text",
      { x: "320", y: "255" },
      "Praha"
    )
  );
});